export default __webpack_public_path__ + "device_spotlight_cam_wired.30299736.png";